import styled from "styled-components";

import { windowWidth } from "@styles/global";

const OfficeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  height: 100vh;
`;

const OfficeNavbarContainer = styled.div`
  position: relative;
  width: 100%;
`;

const OfficeContentContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  overflow-y: scroll;

  > :first-child {
    min-width: 60px;

    @media (max-width: ${windowWidth.webDefault}) {
      display: none;
    }
  }
`;

const OfficeContent = styled.div<{ $fill?: boolean }>`
  flex-grow: 1;
  height: 100%;
  width: 100%;
  color: ${(props) => props.theme.colors.text};
  overflow-y: ${({ $fill }) => ($fill ? "hidden" : "scroll")};
`;

export {
  OfficeContainer,
  OfficeNavbarContainer,
  OfficeContentContainer,
  OfficeContent
};
